export const APP_VERSION  = process.env.REACT_APP_VERSION  || '3.60.0';
export const APP_ENV      = process.env.NODE_ENV === 'production' ? 'Production' : 'Development';
export const BUILD_DATE   = process.env.REACT_APP_BUILD_DATE || null;
